<!--  -->
<template>
    <div class='serviceRow'>
        <div class='content'>
            <div class="title">专业服务</div>
            <div class="subtitle">专注服务街道与社区，提供专业服务</div>
            <div class='content serviceContent'>
                <div class="serviceItem" v-for="(item,index) in datalist" :key="index" :class="{right:isPhone && index%2}">
                    <img class="serviceImg" src="../../../assets/images/showProduct/service1.png"/>
                    <div class="serviceShadow"></div>
                    <div class="serviceName"><div class="columName">{{item.title}}</div></div>
                    <div class="serviceSubName">{{item.content}}</div>
                </div>
            </div>
        </div>
        <div class="serviceContact">
            <div class="xian"></div>
            <div class="serviceTitle2">开启社区工作新时代</div>
            <div class="serviceButton">立即注册</div>
            <div class="servicePhone"><span class="iconfont icon-zuoji"></span>咨询电话：010-66163035</div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    props:{
        isPhone:{
            type:Boolean,
            default:false
        }
    },
    data() {
    //这里存放数据
        return {
            datalist:[{
                title:'月坛街道',
                content:'基层治理平台可以直接在微信中使用，很方便，这也是我们选择它的原因之一。社区公告、党员学习、活动报名等功能都很实用。'
            },{
                title:'东辛房街道',
                content:'基层治理平台可以直接在微信中使用，很方便，这也是我们选择它的原因之一。社区公告、党员学习、活动报名等功能都很实用。'
            },{
                title:'中仓街道',
                content:'基层治理平台可以直接在微信中使用，很方便，这也是我们选择它的原因之一。社区公告、党员学习、活动报名等功能都很实用。'
            }]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>

<style src="../pc.css" scoped></style>
<style src="../phone.css" scoped></style>